import { APP_INITIALIZER } from '@angular/core';
import { ConfigService } from '../services/config.service';

export function loadRuntimeConfig(
  configService: ConfigService,
): () => Promise<void> {
  return () => configService.loadAppConfig();
}

export const configInitializerProvider = {
  provide: APP_INITIALIZER,
  useFactory: loadRuntimeConfig,
  multi: true,
  deps: [ConfigService],
};
